import { get, values } from 'lodash-es';
import commonBaseService from '../../../services/commonBaseService';

export const getSelectedCategoryData = (
	marketWatchData = {},
	categoryName = '',
) => {
	const marketWatchCategoryData = get(marketWatchData, 'data', {});
	const categoryData = get(marketWatchCategoryData, `${categoryName}`, []);
	return categoryData;
};

export const getSelectedCategoryCount = (
	marketWatchData = {},
	categoryName = '',
) => {
	const categoryData = getSelectedCategoryData(marketWatchData, categoryName);
	const categoryCount = get(categoryData, 'count', 0);
	return categoryCount;
};

export const getSelectedCategoryList = (
	marketWatchData = {},
	categoryName = '',
) => {
	const categoryData = getSelectedCategoryData(marketWatchData, categoryName);
	const categoryList = get(categoryData, 'data', []);
	return categoryList;
};

export const getMarketWatchTokenList = (
	marketWatchData = {},
	isGuestUser = false,
) => {
	const marketWatchScreeners = values(marketWatchData);
	const tokenList = [];
	marketWatchScreeners?.forEach((screenerItem) => {
		let screenerItemList = get(screenerItem, 'data', []);

		const shouldSliceTokenList =
			isGuestUser &&
			!commonBaseService.isEmptyOrUndefined(screenerItemList) &&
			screenerItemList.length > 5;

		if (shouldSliceTokenList) {
			screenerItemList = screenerItemList.slice(0, 5);
		}

		screenerItemList?.map((el) => {
			const tokenData = {
				token: el?.nToken,
				marketSegment: el?.nMarketSegmentId,
			};
			tokenList.push(tokenData);
		});
	});
	return tokenList;
};

export const MARKET_WATCH_INDEX_LIST = [
	{
		name: 'NIFTY 50',
		id: 'Nifty 50',
		segment: 1,
	},
	{
		name: 'BANK NIFTY',
		id: 'Nifty Bank',
		segment: 1,
	},
	{
		name: 'NIFTY 100',
		id: 'Nifty 100',
		segment: 1,
	},
	{
		name: 'SENSEX 30',
		id: 'SENSEX',
		segment: 8,
	},
	{
		name: 'NIFTY MIDCAP 50',
		id: 'Nifty Midcap 50',
		segment: 1,
	},
	{
		name: 'NIFTY IT',
		id: 'Nifty IT',
		segment: 1,
	},
	{
		name: 'NIFTY PHARMA',
		id: 'Nifty Pharma',
		segment: 1,
	},
	{
		name: 'NIFTY PSU BANK',
		id: 'Nifty PSU Bank',
		segment: 1,
	},
	{
		name: 'NIFTY PRIVATE BANK',
		id: 'Nifty Pvt Bank',
		segment: 1,
	},
	{
		name: 'NIFTY FMCG',
		id: 'Nifty FMCG',
		segment: 1,
	},
	{
		name: 'NIFTY AUTO',
		id: 'Nifty Auto',
		segment: 1,
	},
	{
		name: 'NIFTY ENERGY',
		id: 'Nifty Energy',
		segment: 1,
	},
	{
		name: 'NIFTY INFRASTRUCTURE',
		id: 'Nifty Infra',
		segment: 1,
	},
	{
		name: 'NIFTY METAL',
		id: 'Nifty Metal',
		segment: 1,
	},
];
const EMPTY_STRING_VARIANT = {
	PriceGainers_: `are showing gains today`,
	PriceLoosers_: `are on the decline today`,
	'52WeekHigh_': `have reached a 52-week high today`,
	'52WeekLow_': `have reached a 52-week low today`,
};
export const marketWatchEmptyText = (selectedIndex = '', selectedTab = '') => {
	return `No stocks within ${selectedIndex} ${EMPTY_STRING_VARIANT[selectedTab]}`;
};
